import {
  CompleteFn,
  ErrorFn,
  GoogleAuthProvider,
  NextOrObserver,
  PopupRedirectResolver,
  Unsubscribe,
  User,
  UserCredential,
  browserSessionPersistence,
  connectAuthEmulator,
  getAuth,
  onAuthStateChanged,
  setPersistence,
  signInWithPopup,
  signOut,
} from 'firebase/auth';
import { firebaseApp } from '../firebase/firebase.client';

const firebaseAuth = getAuth(firebaseApp);

if (process.env.REACT_APP_USE_EMULATOR === 'true') {
  connectAuthEmulator(firebaseAuth, `http://${location.hostname}:9099`);
}

setPersistence(firebaseAuth, browserSessionPersistence);

const firebaseAuthGoogleProvider = new GoogleAuthProvider();

class FirebaseAuthenticationClient {
  static singInGoogle(resolver?: PopupRedirectResolver): Promise<UserCredential> {
    return signInWithPopup(firebaseAuth, firebaseAuthGoogleProvider, resolver);
  }

  static singOut(): Promise<void> {
    return signOut(firebaseAuth);
  }

  static onStateChange(nextOrObserver: NextOrObserver<User>, error?: ErrorFn, completed?: CompleteFn): Unsubscribe {
    return onAuthStateChanged(firebaseAuth, nextOrObserver, error, completed);
  }

  /**
   * ID token da sessao corrente, para autenticar na API.
   *
   * Aguarda o SDK terminar de restaurar a sessao antes de ler `currentUser`.
   * Sem essa espera, toda chamada disparada no primeiro render falha: o
   * `projectId` vem do localStorage e ja esta definido, entao as telas montam
   * antes de o Firebase resolver quem esta logado.
   *
   * O SDK renova o token sozinho quando falta menos de 5 minutos para expirar;
   * `forceRefresh` serve para releitura imediata de custom claims.
   */
  static async getIdToken(forceRefresh = false): Promise<string | null> {
    await firebaseAuth.authStateReady();

    const { currentUser } = firebaseAuth;

    if (currentUser === null) return null;

    return currentUser.getIdToken(forceRefresh);
  }
}

export { FirebaseAuthenticationClient };
